import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClickOutsideModule } from 'ng-click-outside';
import { AlertComponent } from './components/alert/alert.component';
import { BasicRadioComponent } from './components/basic-radio/basic-radio.component';
import { BackButtonComponent } from './components/button/back-button/back-button.component';
import { ButtonComponent } from './components/button/button.component';
import { NextButtonComponent } from './components/button/next-button/next-button.component';
import { PrimaryButtonComponent } from './components/button/primary-button.component';
import { RedButtonComponent } from './components/button/red-button.component';
import { SecondaryButtonComponent } from './components/button/secondary-button.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { DataPointComponent } from './components/data-point/data-point.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DetailedProductDescriptionComponent } from './components/detailed-product-description/detailed-product-description.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { HeaderBarComponent } from './components/header-bar/header-bar.component';
import { LabelFieldComponent } from './components/label-field/label-field.component';
import { LoadingComponent } from './components/loading/loading.component';
import { RadioComponent } from './components/radio/radio.component';
import { ScreenContentComponent } from './components/screen-content/screen-content.component';
import { SectionHeaderComponent } from './components/section-header/section-header.component';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { DragAndDropDirective } from './directives/drag-and-drop.directive';
import { ScrollSpyDirective } from './directives/scroll-spy.directive';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { DisableFormControlDirective } from './directives/disable-form-control.directive';
import { DisableMouseWheelDirective } from './directives/disable-mouse-wheel.directive';

@NgModule({
  declarations: [
    TimeAgoPipe,
    HeaderBarComponent,
    SideBarComponent,
    FileUploadComponent,
    DragAndDropDirective,
    ScrollSpyDirective,
    ButtonComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    RedButtonComponent,
    RadioComponent,
    DetailedProductDescriptionComponent,
    DropdownComponent,
    CheckboxComponent,
    SectionHeaderComponent,
    AlertComponent,
    LoadingComponent,
    ScreenContentComponent,
    BackButtonComponent,
    NextButtonComponent,
    DataPointComponent,
    DatePickerComponent,
    LabelFieldComponent,
    BasicRadioComponent,
    DisableFormControlDirective,
    DisableMouseWheelDirective,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    ClickOutsideModule,
  ],
  exports: [
    HeaderBarComponent,
    SideBarComponent,
    TimeAgoPipe,
    FileUploadComponent,
    ScrollSpyDirective,
    ButtonComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    RedButtonComponent,
    RadioComponent,
    DropdownComponent,
    CheckboxComponent,
    SectionHeaderComponent,
    AlertComponent,
    LoadingComponent,
    ScreenContentComponent,
    BackButtonComponent,
    NextButtonComponent,
    DataPointComponent,
    DatePickerComponent,
    LabelFieldComponent,
    BasicRadioComponent,
    DisableFormControlDirective,
    DisableMouseWheelDirective,
  ],
})
export class SharedComponentsModule {}
